export default __webpack_public_path__ + "proximanova-regular-webfont.woff2";